import { OFFER_PRICE_TYPES } from "app/constants";

const SCHEMA_CONTEXT = "https://schema.org";

const RELIABLE_PRICE_TYPES = [
	OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM,
	OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM_WITH_FLIGHT,
	OFFER_PRICE_TYPES.FROM_PRICE_TYPE_EXCLUSIVE,
	OFFER_PRICE_TYPES.FROM_PRICE_TYPE_SAVE_UP_TO,
];

export const hasReliablePrice = fromPriceType =>
	RELIABLE_PRICE_TYPES.includes(fromPriceType?.type) && Number(fromPriceType?.value) > 0;

export const buildOrganizationSchema = ({ id, name, url, logo, sameAs } = {}) => {
	if (!name || !url) {
		return null;
	}

	return {
		"@type": "Organization",
		"@id": id || `${url}#organization`,
		name,
		url,
		...(logo ? { logo } : {}),
		...(sameAs?.length ? { sameAs } : {}),
	};
};

export const buildBreadcrumbSchema = ({ items = [] } = {}) => {
	const validItems = items.filter(item => item?.name && item?.url);

	if (validItems.length < 2) {
		return null;
	}

	return {
		"@type": "BreadcrumbList",
		"@id": `${validItems[validItems.length - 1].url}#breadcrumb`,
		itemListElement: validItems.map((item, index) => ({
			"@type": "ListItem",
			position: index + 1,
			name: item.name,
			item: item.url,
		})),
	};
};

export const buildProductSchema = ({
	name,
	url,
	sku,
	image,
	category,
	price,
	priceCurrency,
} = {}) => {
	if (!name || !url) {
		return null;
	}

	const canRenderOffer = Boolean(price) && Boolean(priceCurrency);

	return {
		"@type": "Product",
		"@id": `${url}#product`,
		name,
		...(sku ? { sku: String(sku) } : {}),
		...(category ? { category } : {}),
		url,
		...(image ? { image } : {}),
		...(canRenderOffer
			? {
					offers: {
						"@type": "Offer",
						url,
						price: String(price),
						priceCurrency,
						availability: "https://schema.org/InStock",
					},
				}
			: {}),
	};
};

export const buildGraph = (...nodes) => {
	const graph = nodes.filter(Boolean);

	if (!graph.length) {
		return null;
	}

	return {
		"@context": SCHEMA_CONTEXT,
		"@graph": graph,
	};
};
